import { useState, useEffect } from "react";
import config from "../config/config";
import { userSession } from "../observers/userObserver";

const useCountries = () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const storedCountries = localStorage.getItem("countries");
        if (storedCountries) {
          setCountries(JSON.parse(storedCountries)); // Use cached data
          return;
        }

        const response = await fetch(`${config["backend-url"]}/get_country`, {
          method: 'GET', // Explicitly specify the method
          headers: {
            Authorization: `Bearer ${userSession.getToken()}`,
            'Content-Type': 'application/json'
          }
        });
        
        const data = await response.json();
        if (response.ok) {
          setCountries(data);
          localStorage.setItem("countries", JSON.stringify(data)); // Cache data
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  return countries;
};

export default useCountries;
